import { DemoData, IOrganization, ISyncByOrganizations, recipientsTransformation } from '../types';
import { Fetch } from './Fetch';

export const Organization = {
	valueToObject: (body:IOrganization) => {
		if (recipientsTransformation.valueToObject && body.PrimaryLicensesNotificationRecepients) {
			const data = { ...body };
			const recipients: any = body.PrimaryLicensesNotificationRecepients;
			data.PrimaryLicensesNotificationRecepients = recipientsTransformation.valueToObject(recipients);
			return data;
		}
		return body;
	},

	get: async (id: string): Promise<IOrganization> =>
		DemoData.enabled ? 
			DemoData.getOrganization(id) :
			Fetch.get(`/management/organization/${id}`),

	put: (id: string, body: IOrganization) =>
		DemoData.enabled ?
		DemoData.putOrganization(id,body) :
		Fetch.put(`/management/organization/${id}`, Organization.valueToObject(body) ),

	post: (body: IOrganization) => 
		Fetch.post('/management/organization', Organization.valueToObject(body)),

	getSyncByOrganizations: async (id: string): Promise<ISyncByOrganizations> =>
		Fetch.get(`/management/organization/${id}/stats`),

	listUrl: '/management/organizations',
	getPostUrl: (id?: string) => `/management/organization${id ? '/' + id : ''}`,
	getListUrl: (query?: string) => Fetch.buildUrl( Organization.listUrl, query),
	auditLogsUrl: (id: string) => `/management/organization/${id}/auditlogs`,
	urlsUrl: (id: string) => `/management/organization/${id}/urls`,
	usersUrl: (id: string) => `/management/organization/${id}/users`,
	syncByUsersUrl: (id: string, query?: string) => Fetch.buildUrl(`/management/organization/${id}/stats/users`, query),
	syncByDevicesUrl: (id: string, query?: string) => Fetch.buildUrl(`/management/organization/${id}/stats/devices`, query)
}
